import { NgModule } from "@angular/core";

import { CoreModule } from "./core/core.module";
import { SharedModule } from "./shared/shared.module";

import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./layout/header/header.component";
import { PageLoaderComponent } from "./layout/page-loader/page-loader.component";
import { SidebarComponent } from "./layout/sidebar/sidebar.component";
import { RightSidebarComponent } from "./layout/right-sidebar/right-sidebar.component";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
import { fakeBackendProvider } from "./core/interceptor/fake-backend";
import { ErrorInterceptor } from "./core/interceptor/error.interceptor";
import { JwtInterceptor } from "./core/interceptor/jwt.interceptor";
import { LocationStrategy, HashLocationStrategy, DatePipe, CurrencyPipe } from "@angular/common";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ToastModule } from 'primeng/toast';
import {
    HttpClientModule,
    HTTP_INTERCEPTORS,
    HttpClient,
} from "@angular/common/http";
import { ButtonModule } from "primeng/button";

import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { NgScrollbarModule } from "ngx-scrollbar";
import { CapitalizePipe } from "./util/pipeCapitalize";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MAT_DATE_LOCALE, MatNativeDateModule } from "@angular/material/core";
import { SolicitarAudienciaComponent } from './paginas/audiencias/solicitar-audiencia/solicitar-audiencia.component';
import { ConsultarAudienciaComponent } from './paginas/audiencias/consultar-audiencia/consultar-audiencia.component';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MessageService, PrimeNGConfig } from "primeng/api";
import { MatSelectModule } from "@angular/material/select";

import { OwlDateTimeModule, OwlNativeDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { CelebrarAudienciaComponent } from "./paginas/audiencias/celebrar-audiencia/celebrar-audiencia.component";
import { CrearProgramacionAudienciaComponent } from "./paginas/audiencias/crear-programacion-audiencia/crear-programacion-audiencia.component";
import { AudienciaModule } from "./paginas/audiencias/audiencia.module";
// import { PlantillaPruebaComponent } from './paginas/pruebas/plantilla-prueba/plantilla-prueba.component';
import { ComponentsModule } from "./shared/components/components.module";
import { PRIMENG_ES } from "./i18n/primeng-es";
import { UploadModule } from "./paginas/upload/upload.module";
import { GenerarPlanoComponent } from './paginas/plano-simit/generar-plano/generar-plano.component';
import { CargueSimitComponent } from './paginas/plano-simit/cargue-simit/cargue-simit.component';
import { ConsultarPlanosComponent } from './paginas/plano-simit/consultar-planos/consultar-planos.component';
import { InactivityService } from "./services/inactividad/inactivity.service";
import { LoadingComponent } from "./util/loadingComponent";




export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        PageLoaderComponent,
        SidebarComponent,
        RightSidebarComponent,
        AuthLayoutComponent,
        MainLayoutComponent,
        CapitalizePipe,
        LoadingComponent,

    ],
    imports: [
        MatNativeDateModule,
        MatDatepickerModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        BrowserModule,
        MatSelectModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        LoadingBarRouterModule,
        NgScrollbarModule,
        ToastModule,
        MatProgressSpinnerModule,
        ButtonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        // core & shared
        CoreModule,
        SharedModule,
        ComponentsModule,
        UploadModule
    ],
    providers: [
        InactivityService,
        MessageService, CurrencyPipe,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        DatePipe,
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        { provide: MatDialogRef, useValue: {} },



    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private primengConfig: PrimeNGConfig) {
        this.primengConfig.setTranslation(PRIMENG_ES);
    }
}
